import axios from "axios";
import { domain } from "../../../Links/Links";
import { getCookie } from "../../../../App";

export async function bankAccountsRequest(setRequestStatus, setData) {
  setRequestStatus(true);

  const response = await axios.get(domain + "/bank_accounts/", {
    withCredentials: true,
  });

  if (response.data) {
    setData(response.data);
    setRequestStatus(false);
  }
}
